module.exports = __webpack_public_path__ + "images/signup/woman.c7c7a212.svg";